import type { BusAd, CarAd, ConstructionAd, MobileHomeAd, TruckAd } from "@mobility-item-page/types";
import { Effect } from "./Effect.tsx";
import type { SpecProps } from "./types.ts";
import { VolumeLitre } from "./VolumeLitre.tsx";

export const Engine = ({ engine }: SpecProps<"engine", BusAd | CarAd | ConstructionAd | MobileHomeAd | TruckAd>) => {
  return (
    <>
      <Effect effect={engine?.effect} />
      <VolumeLitre volume={engine?.volume} />
    </>
  );
};
